var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ErrorBlank"},[_c('div',{staticClass:"ErrorBlank-body"},[_c('div',{staticClass:"ErrorBlank-body-backDoor",on:{"click":_vm.backDoor}},[_vm._v("返回登录页")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }